import React from 'react';
import styles from './IndicatorLevelRail.module.scss';

const BackIcon = () => <svg viewBox="0 0 36 36" aria-hidden="true"><path d="M10 13.2 4.8 18.4 10 23.6"/><path d="M5.6 18.4h13.1a8.7 8.7 0 1 1 0 17.4H14"/></svg>;
const PilotageIcon = () => <svg viewBox="0 0 36 36" aria-hidden="true"><path d="M7 27.5V18.8M14.5 27.5V9.5M22 27.5V14.4M29.5 27.5V5.5"/><path d="M5 29.5h26"/></svg>;

const IndicatorLevelRail = ({viewingInsights, onOpenInsights, onReturnDashboard}) => {
    return <nav className={styles.rail} aria-label="Navigation de l’indicateur">
        <div className={styles.items}>
            <button className={styles.item} onClick={onReturnDashboard} title="Revenir au tableau de bord">
                <span className={styles.icon}><BackIcon/></span>
                <span>Revenir</span>
            </button>

            <span className={styles.divider} aria-hidden="true"/>

            <button className={`${styles.item} ${viewingInsights ? styles.active : ''}`} onClick={onOpenInsights} title="Ouvrir le pilotage">
                <span className={styles.icon}><PilotageIcon/></span>
                <span>Pilotage</span>
            </button>
        </div>
    </nav>;
};

export default IndicatorLevelRail;
